module.exports = __webpack_public_path__ + "media/images/welcome2-121d44343e5f04eaec377f5b405b3136.jpg";